export var CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY = 'cross-platform-sidebar-collaborator';